module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00183.b7f4abf8.jpg";